import React, { type ReactElement, useEffect } from 'react'
import { useAppDispatch } from 'store/hooks'
import { resetState } from 'features/vendors/vendorList.slice'

import WelcomeHeader from '../../ui/welcome-header'

import styles from './MyOffersContainer.module.scss'
import MyOffers from './my-offers'

const MyOffersContainer: React.FC = (): ReactElement => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetState())
    }
  }, [])

  return (
    <div className={styles.container}>
      <WelcomeHeader
        title={'Dobrodošli na stranicu MOJE PONUDE'}
        subtitle={
          'Ovde možete videti spisak svih ponuda koje ste poslali , njihov status kao i datum završetka. Klikom na dugme detalji možete videti detalje svoje ponude.'
        }
      />
      <MyOffers />
    </div>
  )
}

export default MyOffersContainer
